import { cloneDeep } from 'lodash';
import { InfiniteData } from 'react-query';
import { DjangoListResponse } from 'v2/models';

type RequiredDataProps = {
  id: number;
};

function updatePages<T extends RequiredDataProps>(
  pages: DjangoListResponse<T>[],
  data: T
) {
  for (const page of pages) {
    const dataIndex = page.results.findIndex((item) => item.id === data.id);

    if (dataIndex !== -1) {
      page.results[dataIndex] = data;
      break;
    }
  }
}

export function updateInfiniteData<T extends RequiredDataProps>(
  data: InfiniteData<DjangoListResponse<T>> | undefined,
  update: T
) {
  if (data === undefined)
    return {
      pages: [],
      pageParams: [],
    };

  const updatedData = cloneDeep(data);
  updatePages(updatedData.pages, update);

  return updatedData;
}
